var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{ref:"lszshj",staticStyle:{"width":"800px","height":"200px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }